export const environment = {
  production: false,
  endPoint: 'https://nonprod-qa-api.visor.health/visor/',
  careOutreachBaseUrl: 'https://nonprod-qa-api.visor.health/visor/',
  externalGateway: 'https://nonprod-qa-api.visor.health/visor/',
  visorBaseUrl: 'https://nonprod-qa-api.visor.health/visor/',
  // endPoint: 'https://careecoapiqa.herokuapp.com/careeco/',
  userWebUrl: 'https://nonprod-qa-app.visor.health',
  providerConnetUrl: 'https://nonprod-qa-provider.visor.health',
  windowName: 'ProviderConnectQa',
  telehealthUrl : "https://nonprod-qa-telehealth.visor.health"

};
